export default __webpack_public_path__ + "649e7c0959e24bd84154c2bc07f52537.svg";